<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="工序计件工价"
      edit-title
      id-key="ProcessWagesId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="工序" label-width="100px">
              <el-select v-model="data.ProcessId" clearable>
                <el-option v-for="item in teProcessList" :key="item.ProcessId" :value="item.ProcessId" :label="item.ProcessName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="条件" label-width="100px">
              <el-input v-model="data.Condition" style="width: 200px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="加工单元" label-width="100px">
              <el-select v-model="data.ProcessUnitId" clearable>
                <el-option v-for="item in teProcessUnitList" :key="item.ProcessUnitId" :value="item.ProcessUnitId" :label="item.ProcessUnitName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加工阶段" prop="ProcessStage" label-width="100px">
              <el-select v-model="data.Stage" clearable>
                <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="计件单位" label-width="100px">
              <el-select v-model="data.PieceUnitId">
                <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计件工价" label-width="100px">
              <el-input v-model="data.PiecePrice" style="width: 200px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import invoiceSelect from "@/components/basedata/basedoc/billtype/select";
import accountSelect from "@/components/business/sales/select";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    invoiceSelect,
    accountSelect
  },
  data() {
    return {
      api: require("@/api/pr/prProcessWages").default,
      formApi: require("@/api/sy/formSetting").default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      teProcessApi: require("@/api/production/teProcess").default,
      teProcessUnitApi: require("@/api/production/teProcessUnit").default,
      unitApi: require("@/api/ba/unit").default,
      pdApi: require("@/api/ba/product").default,
      data: {
        ProcessWagesId: 0,
        ProductId: null,
        ProductName: null,
        ProductNo: null,
        ProductSpec: null,
        ColorId: null,
        Stage: null,
        ProcessUnitId: null,
        ProcessId: null,
        PieceUnitId: null,
        Condition: null,
        PiecePrice: null,
      },
      showList: [],
      machiningStageList: [],
      teProcessList: [],
      teProcessUnitList: [],
      unitList: [],
      DAccount: [],
      initDAccount: [],
      colorList: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      rules: {
        // TransportNo: [{ required: true, message: "请输入编号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
      
      this.machiningStageApi.list({ Status: 1 }).then((res) => {
        this.machiningStageList = res.Data;
      });
      this.teProcessApi.list({ Status: 1 }).then((res) => {
        this.teProcessList = res.Data;
      });
      this.teProcessUnitApi.list({ Status: 1 }).then((res) => {
        this.teProcessUnitList = res.Data;
      });
      this.unitApi.list({Status: 1}).then((res) => {
        this.unitList = res.Data.filter((item) => item.IsGroup == false);
      });

      this.pdApi
        .list({ Property: "加工", pageIndex: 1, pageSize: 7, Status: 1 })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(data) {
      this.data.ProcessWagesId = 0
      // this.api.getMaxSn().then((res) => {
      //   this.data.Sn = res;
      // });
    },
    onEditOpened(data) {
      this.api.info(data.ProcessWagesId).then((res) => {
        // console.log("🚀 ~ this.api.info ~ res:", res)
        this.colorList = res.Data.Colors
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
